"use client";

import { globalStyleObj } from "@/app/assets/styles";
import React, { useCallback, useMemo, useRef } from "react";
import { LabelText } from "..";
import dynamic from "next/dynamic";
import { useTheme } from "next-themes";
import { createJoditConfig } from "@/config/jodit-editor.config";

const JoditEditor = dynamic(
  () => import("jodit-react"),
  { ssr: false } // This is key
);

const CommonJoditReactTextEditor = ({
  value = "",
  labelText = "",
  filedId = "",
  fieldName = "",
  fieldStatus = false,
  onTextEditorChange = () => {},
  isItemDetailsExist = false,
  extraClass = "",
  inputContainerMaxWidth = "max-w-[800px]",
}) => {
  const { theme } = useTheme();
  const editor = useRef(null);

  // Debounced change handler
  const handleChange = useCallback(
    (newContent) => {
      // Basic XSS prevention
      const cleanContent = newContent
        .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "")
        .replace(/javascript:/gi, "")
        .replace(/on\w+\s*=/gi, "");

      onTextEditorChange(cleanContent);
    },
    [onTextEditorChange]
  );

  return (
    <div
      className={`${globalStyleObj.commonInputContainerClass} ${extraClass}`}
    >
      <LabelText
        text={labelText}
        htmlForId={`${isItemDetailsExist ? `update-${filedId}` : `${filedId}`}`}
        star={fieldStatus}
        translateField={isItemDetailsExist}
      />

      <div
        className={`w-full ${inputContainerMaxWidth} rounded-sm border border-[#000]/20 dark:border-[#fff]/10 ${theme === "dark" ? "jodit-dark" : "jodit-light"}`}
      >
        <JoditEditor
          ref={editor}
          id={`${isItemDetailsExist ? `update-${filedId}` : `${filedId}`}`}
          value={value || ""}
          name={fieldName}
          onChange={(newContent) => handleChange(newContent)}
          // config={config}
        />
      </div>
    </div>
  );
};

export default CommonJoditReactTextEditor;
